import React, { useRef } from 'react';
import FileUpload from './FileUpload';
import GeocodeSettings from './GeocodeSettings';
import { handleFileRead } from '../utils/fileHelpers';
import './FileUploadSection.scss';

const FileUploadSection = ({
  onShipmentsFileChange,
  onVehiclesFileChange,
  onGenerateJson,
  onClearAll,
  onSetErrors,
  totalShipments,
  totalVehicles,
}) => {
  const shipmentsFileInputRef = useRef(null);
  const vehiclesFileInputRef = useRef(null);

  const handleError = (message) => {
    onSetErrors([message]);
  };

  const handleShipmentsFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    shipmentsFileInputRef.current.value = '';
    handleFileRead(file, onShipmentsFileChange, handleError);
  };

  const handleVehiclesFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    vehiclesFileInputRef.current.value = '';
    handleFileRead(file, onVehiclesFileChange, handleError);
  };

  return (
    <div className="FileUploadSection">
      <h2>Input</h2>
      <GeocodeSettings />
      <div className="upload-container">
        <div className="upload-box">
          <h3>Shipments</h3>
          <FileUpload
            onChange={handleShipmentsFileChange}
            inputRef={shipmentsFileInputRef}
            successText={totalShipments > 0 ? `${totalShipments} shipments uploaded!` : ''}
          />
          <div className="sample-file">
            <a href="/shipments-vrp.csv" target="_blank">
              shipments-vrp.csv
            </a>
            {', '}
            <a href="/shipments-pdp.csv" target="_blank">
              shipments-pdp.csv
            </a>
          </div>
        </div>

        <div className="upload-box">
          <h3>Vehicles</h3>
          <FileUpload
            onChange={handleVehiclesFileChange}
            inputRef={vehiclesFileInputRef}
            successText={totalVehicles > 0 ? `${totalVehicles} vehicles uploaded!` : ''}
          />
          <div className="sample-file">
            <a href="/vehicles.csv" target="_blank">
              vehicles.csv
            </a>
          </div>
        </div>
      </div>
      <div className="action-buttons">
        <button className="generate-button" onClick={onGenerateJson}>
          Generate
        </button>
        <button className="clear-all-button" onClick={onClearAll}>
          Clear All
        </button>
      </div>
    </div>
  );
};

export default FileUploadSection;
